import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer';
import { Messages } from '../../model/Message';
import { convertDateToJapaneseStringWithWeekZero, convertTimeToString } from '../../utility/ConvertUtily';

Font.registerHyphenationCallback(word => Array.from(word).flatMap(char => [char, '']));

export type EventCodePDFProps = {
  message: Messages;
  qrCodeData: string;
};

export const EventCodePDF = ({ message, qrCodeData }: EventCodePDFProps) => {
  Font.register({
    family: "BIZUDPGothic",
    fonts: [
      {
        src: "/fonts/BIZUDPGothic-Regular.ttf",
      },
      {
        src: "/fonts/BIZUDPGothic-Bold.ttf",
        fontWeight: "bold",
      },
    ],
  });

  const styles = StyleSheet.create({
    page: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#FFFFFF',
      fontFamily: "BIZUDPGothic",
      fontWeight: "bold",
      justifyContent: 'center',
      alignItems: 'center',
    },
    contentContainer: {
      width: '90%',
      alignItems: 'center',
    },
    textContainer: {
      width: '80%',
      margin: '0 auto',
      textAlign: 'center',
      alignItems: 'center',
    },
    title: {
      fontSize: 25,
      textAlign: 'center',
      lineHeight: 1.2,
    },
    titleLeft: {
      textAlign: 'left',
    },
    titleContainer: {
      marginBottom: 20,
    },
    eventAt: {
      fontSize: 20,
      marginBottom: 10,
      textAlign: 'center',
    },
    qrCode: {
      width: 300,
      height: 300,
      margin: 0,
      textAlign: 'center',
    },
  });

  const splitTitle = (title: string, length: number): string[] => {
    let currentLength = 0;
    let currentLine = '';
    const lines = [];

    for (const char of title) {
      currentLength += char.match(/[ -~]/) ? 0.5 : 1;
      currentLine += char;

      if (currentLength >= length) {
        lines.push(currentLine);
        currentLength = 0;
        currentLine = '';
      }
    }

    if (currentLine) {
      lines.push(currentLine);
    }

    return lines;
  };

  const titleLines = splitTitle(message.title, 16);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.contentContainer}>
          <View style={styles.textContainer}>
            <View style={styles.titleContainer}>
              {titleLines.length > 1 ? (
                titleLines.map((line, index) => (
                  <Text key={index} style={[styles.title, styles.titleLeft]}>{line}</Text>
                ))
              ) : (
                <Text style={styles.title}>{message.title}</Text>
              )}
            </View>
            <Text style={styles.eventAt}>{`【開催日時】${convertDateToJapaneseStringWithWeekZero(message.eventAt)}`}</Text>
            <Text style={styles.eventAt}>{`　　　${convertTimeToString(message.eventAt)}～${convertTimeToString(message.eventEndAt)}`}</Text>
          </View>
          <Image src={`${qrCodeData}`} style={styles.qrCode} />
        </View>
      </Page>
    </Document>
  );
};